import { render, staticRenderFns } from "./addOilCard.vue?vue&type=template&id=5a511180&scoped=true&"
import script from "./addOilCard.vue?vue&type=script&lang=js&"
export * from "./addOilCard.vue?vue&type=script&lang=js&"
import style0 from "./addOilCard.vue?vue&type=style&index=0&id=5a511180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a511180",
  null
  
)

export default component.exports